(function (global) {
  'use strict';

  var triggerSelector = '#precutss, #fabricss, #notionsss';
  var focusableSelector = 'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function setOpen(element, open, addOpeningClass) {
    if (!element) return;

    if (open) {
      element.setAttribute('open', '');
      if (element.classList) {
        if (addOpeningClass === false) {
          element.classList.add('menu-opening-pending');
        } else {
          element.classList.add('menu-opening');
        }
      }
    } else {
      element.removeAttribute('open');
      if (element.classList) {
        element.classList.remove('menu-opening');
        element.classList.remove('menu-opening-pending');
      }
    }
  }

  function setDisclosureOpen(element, open, addOpeningClass) {
    setOpen(element, open, addOpeningClass);
    if (!element) return;

    var summary = element.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function createController(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll(triggerSelector));
    var drawer = root.getElementById('Details-menu-drawer-container');
    var drawerComponent = root.querySelector('header-drawer');
    var department = root.getElementById('Details-menu-drawer-menu-item-1');
    var parentSubmenu = department ? department.closest('.has-submenu') : null;
    var drawerToggle = root.querySelector('.header__icon.header__icon--menu');
    var activeTrigger = null;
    var pendingOpenTimer = null;
    var pendingTrigger = null;
    var focusRequest = 0;
    var pendingFocusTimer = null;

    function cancelPendingOpen() {
      if (pendingOpenTimer === null) return;
      global.clearTimeout(pendingOpenTimer);
      if (pendingTrigger) pendingTrigger.setAttribute('aria-expanded', 'false');
      pendingOpenTimer = null;
      pendingTrigger = null;
    }

    function cancelPendingFocus() {
      if (pendingFocusTimer !== null) {
        global.clearTimeout(pendingFocusTimer);
        pendingFocusTimer = null;
      }
      focusRequest += 1;
    }

    function nativeCloseStarted() {
      cancelPendingOpen();
      cancelPendingFocus();
      [drawer, department].forEach(function (element) {
        if (element && element.classList) element.classList.remove('menu-opening-pending');
      });
    }

    function watchNativeSummary(details) {
      if (!details) return;
      var summary = details.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function () {
        if (details.hasAttribute('open')) nativeCloseStarted();
      });
    }

    function isClosing(element) {
      return element && element.hasAttribute('open') && element.classList &&
        !element.classList.contains('menu-opening') && !element.classList.contains('menu-opening-pending');
    }

    function hasClosingNestedPanel() {
      if (!drawer) return false;
      return Array.prototype.slice.call(drawer.querySelectorAll('details[open]')).some(function (details) {
        return details !== department && isClosing(details);
      });
    }

    function closeNestedPanels(except) {
      if (!drawer) return;

      Array.prototype.slice.call(drawer.querySelectorAll('details[open]')).forEach(function (details) {
        if (details === department || details === except) return;
        setDisclosureOpen(details, false);
      });
    }

    function resetExternalTriggers() {
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function close(restoreFocus) {
      cancelPendingOpen();
      cancelPendingFocus();
      if (drawer && drawer.classList) drawer.classList.remove('menu-opening-pending');
      if (!activeTrigger) return;

      var panel = root.getElementById(activeTrigger.getAttribute('aria-controls'));
      setDisclosureOpen(panel, false);
      setDisclosureOpen(department, false);
      if (parentSubmenu && parentSubmenu.classList) parentSubmenu.classList.remove('submenu-open');
      if (drawerComponent && typeof drawerComponent.closeMenuDrawer === 'function') {
        drawerComponent.closeMenuDrawer({}, activeTrigger);
      } else {
        setOpen(drawer, false);
      }
      activeTrigger.setAttribute('aria-expanded', 'false');
      if (drawerToggle) drawerToggle.setAttribute('aria-expanded', 'false');

      var triggerToRestore = activeTrigger;
      activeTrigger = null;
      if (restoreFocus) triggerToRestore.focus();
    }

    function open(trigger) {
      var panel = root.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      var panelAlreadyVisible = panel.hasAttribute('open') && panel.classList && panel.classList.contains('menu-opening');

      if (activeTrigger === trigger) {
        close(false);
        return;
      }

      if (isClosing(drawer) || isClosing(department) || isClosing(panel) || hasClosingNestedPanel()) {
        cancelPendingOpen();
        pendingTrigger = trigger;
        pendingOpenTimer = global.setTimeout(function () {
          var triggerToOpen = pendingTrigger;
          pendingOpenTimer = null;
          pendingTrigger = null;
          open(triggerToOpen);
        }, 450);
        return;
      }

      cancelPendingOpen();
      cancelPendingFocus();

      if (activeTrigger && activeTrigger !== trigger) {
        var previousPanel = root.getElementById(activeTrigger.getAttribute('aria-controls'));
        setDisclosureOpen(previousPanel, false);
        activeTrigger.setAttribute('aria-expanded', 'false');
        activeTrigger = null;
      }

      closeNestedPanels(panel);
      setOpen(drawer, true, false);
      if (drawerComponent && typeof drawerComponent.openMenuDrawer === 'function') {
        drawerComponent.openMenuDrawer(trigger);
      }
      setDisclosureOpen(department, true, false);
      setDisclosureOpen(panel, true, false);
      trigger.setAttribute('aria-expanded', 'true');
      if (drawerToggle) drawerToggle.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;

      var submenu = panel.querySelector('.menu-drawer__submenu');
      var firstItem = (submenu || panel).querySelector(focusableSelector);
      var currentFocusRequest = ++focusRequest;

      function revealPanel() {
        if (currentFocusRequest !== focusRequest || activeTrigger !== trigger || !panel.hasAttribute('open')) return false;
        [drawer, department, panel].forEach(function (element) {
          if (!element || !element.classList) return;
          element.classList.remove('menu-opening-pending');
          element.classList.add('menu-opening');
        });
        if (parentSubmenu && parentSubmenu.classList) parentSubmenu.classList.add('submenu-open');
        return true;
      }

      function focusFirstItem(event) {
        if (event && event.target !== submenu) return;
        if (submenu) submenu.removeEventListener('transitionend', focusFirstItem);
        if (currentFocusRequest !== focusRequest || activeTrigger !== trigger || !panel.hasAttribute('open')) return;

        if (firstItem && submenu && typeof global.trapFocus === 'function') {
          global.trapFocus(submenu, firstItem);
        } else if (firstItem) {
          firstItem.focus();
        }
      }

      var reducedMotion = typeof global.matchMedia !== 'function' || global.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion || !submenu || panelAlreadyVisible) {
        if (revealPanel()) focusFirstItem();
      } else {
        pendingFocusTimer = global.setTimeout(function () {
          pendingFocusTimer = null;
          if (!revealPanel()) return;
          submenu.addEventListener('transitionend', focusFirstItem);
        }, 100);
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        open(trigger);
      });

      var panel = root.getElementById(trigger.getAttribute('aria-controls'));
      if (panel) {
        watchNativeSummary(panel);
        panel.addEventListener('toggle', function () {
          if (panel.hasAttribute('open')) return;
          cancelPendingOpen();
          if (activeTrigger !== trigger) return;
          cancelPendingFocus();
          var summary = panel.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
          if (parentSubmenu && parentSubmenu.classList) parentSubmenu.classList.remove('submenu-open');
          trigger.setAttribute('aria-expanded', 'false');
          activeTrigger = null;
        });
      }
    });

    if (department) {
      watchNativeSummary(department);
      department.addEventListener('toggle', function () {
        if (department.hasAttribute('open')) return;
        cancelPendingOpen();
        cancelPendingFocus();
        closeNestedPanels(null);
        resetExternalTriggers();
        if (parentSubmenu && parentSubmenu.classList) parentSubmenu.classList.remove('submenu-open');
        activeTrigger = null;
      });
    }

    if (drawer) {
      watchNativeSummary(drawer);
      drawer.addEventListener('click', function (event) {
        if (event.target && typeof event.target.closest === 'function' && event.target.closest('.menu-drawer__close-button')) {
          nativeCloseStarted();
        }
      });
      drawer.addEventListener('toggle', function () {
        if (drawer.hasAttribute('open')) return;
        cancelPendingOpen();
        cancelPendingFocus();
        if (drawer.classList) drawer.classList.remove('menu-opening-pending');
        if (drawerToggle) drawerToggle.setAttribute('aria-expanded', 'false');
        Array.prototype.slice.call(drawer.querySelectorAll('details')).forEach(function (details) {
          setDisclosureOpen(details, false);
        });
        setDisclosureOpen(department, false);
        resetExternalTriggers();
        if (parentSubmenu && parentSubmenu.classList) parentSubmenu.classList.remove('submenu-open');
        activeTrigger = null;
      });
    }

    if (drawerComponent) {
      drawerComponent.addEventListener('focusout', function () {
        global.setTimeout(function () {
          if (typeof drawerComponent.contains === 'function' && !drawerComponent.contains(root.activeElement)) {
            nativeCloseStarted();
          }
        }, 0);
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (pendingOpenTimer !== null) {
        event.preventDefault();
        cancelPendingOpen();
        return;
      }
      if (!activeTrigger) return;
      event.preventDefault();
      close(true);
    });

    return { open: open, close: close };
  }

  function init() {
    if (!document.querySelector(triggerSelector)) return;
    createController(document);
  }

  global.HeaderMenuAccessibility = { createController: createController };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);
